"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteConfirmationPopup = void 0;
var React = require("react");
var Buttons_1 = require("../../Buttons");
var Localization_1 = require("../../Localization");
var SmallModal_1 = require("../../Modals/SmallModal");
var DeleteConfirmationPopup_styles_1 = require("./DeleteConfirmationPopup.styles");
var DeleteConfirmationPopup = function (_a) {
    var children = _a.children, Visible = _a.Visible, OnCloseRequest = _a.OnCloseRequest;
    if (!Visible) {
        return null;
    }
    return (React.createElement(SmallModal_1.SmallModal, { Header: Localization_1.strings.DeleteConfirmationPopup_Label_Header, OnCloseRequest: function () { return OnCloseRequest("Cancel"); }, RenderFooter: function () { return React.createElement(DeleteConfirmationPopup_styles_1.ButtonGroup, null,
            React.createElement(DeleteConfirmationPopup_styles_1.ButtonSpacer, null,
                React.createElement(Buttons_1.SecondaryButton, { Caption: Localization_1.strings.DeleteConfirmationPopup_Action_Cancel, OnClick: function () { return OnCloseRequest("Cancel"); } })),
            React.createElement(Buttons_1.SecondaryButton, { Caption: Localization_1.strings.DeleteConfirmationPopup_Action_Delete, OnClick: function () { return OnCloseRequest("Delete"); } })); } },
        React.createElement(DeleteConfirmationPopup_styles_1.Container, null, children)));
};
exports.DeleteConfirmationPopup = DeleteConfirmationPopup;
